/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import useStore from '../../../store';
import { fileNameEWS } from '../Miscellaneous/export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelSummarizedReportIR({ object = null, ...props }) {
	const { t } = useTranslation();
	const { currentLang } = useStore((state) => state.currentLang);

	return (
		<>
			<Box {...props}>
				<ExcelFile
					filename={fileNameEWS(`Quarter IR Summarized Report`, null, null)}
					element={
						<>
							<Button
								isLoading={false}
								isDisabled={false}
								onClick={() => null}
								leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
								colorScheme="gray"
								variant="solid"
								size="sm"
								borderRadius={c.borderRadius}
								border="1px solid #bdc3c7"
							>
								{t('Export')}
							</Button>
						</>
					}
				>
					{(Array.isArray(object) ? object : [object])?.map((object, i) => {
						if (!object?.labels?.length) return null;

						const data = object?.labels?.map((label, j) => ({
							title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
							valueKHR_q1: object.q1Cells?.[j]?.[0]?.value || '',
							valueFC_q1: object.q1Cells?.[j]?.[1]?.value || '',
							valueTotal_q1: object.q1Cells?.[j]?.[2]?.value || '',
							valueUSD_q1: object.q1Cells?.[j]?.[3]?.value || '',
							valuePercent_q1: object.q1Cells?.[j]?.[4]?.value || '',

							valueKHR_q2: object.q2Cells?.[j]?.[0]?.value || '',
							valueFC_q2: object.q2Cells?.[j]?.[1]?.value || '',
							valueTotal_q2: object.q2Cells?.[j]?.[2]?.value || '',
							valueUSD_q2: object.q2Cells?.[j]?.[3]?.value || '',
							valuePercent_q2: object.q2Cells?.[j]?.[4]?.value || '',

							valueKHR_q3: object.q3Cells?.[j]?.[0]?.value || '',
							valueFC_q3: object.q3Cells?.[j]?.[1]?.value || '',
							valueTotal_q3: object.q3Cells?.[j]?.[2]?.value || '',
							valueUSD_q3: object.q3Cells?.[j]?.[3]?.value || '',
							valuePercent_q3: object.q3Cells?.[j]?.[4]?.value || '',

							valueKHR_q4: object.q4Cells?.[j]?.[0]?.value || '',
							valueFC_q4: object.q4Cells?.[j]?.[1]?.value || '',
							valueTotal_q4: object.q4Cells?.[j]?.[2]?.value || '',
							valueUSD_q4: object.q4Cells?.[j]?.[3]?.value || '',
							valuePercent_q4: object.q4Cells?.[j]?.[4]?.value || '',
						}));

						return (
							<ExcelSheet key={i} data={data} name={object?.code || `Sheet ${i + 1}`}>
								<ExcelColumn label={t('Label')} value="title" />
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ទឹកប្រាក់_ប្រាក់រៀល_(គិតជា លានរៀល)' : 'Q1_AMOUNT_KHR_In Million KHR'}
									value="valueKHR_q1"
								/>
								<ExcelColumn
									label={
										currentLang === 'kh'
											? 'ត្រីមាសទី ១_ទឹកប្រាក់_រូបិយវត្ថុអន្តរជាតិ_(គិតជា លានរៀល)'
											: 'Q1_AMOUNT_Foreign Currency_In Million KHR'
									}
									value="valueFC_q1"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ទឹកប្រាក់_សរុប_(គិតជា លានរៀល)' : 'Q1_AMOUNT_Total_In Million KHR'}
									value="valueTotal_q1"
								/>
								<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ទឹកប្រាក់_ដុល្លារ​អាមេរិក' : 'Q1_AMOUNT_USD'} value="valueUSD_q1" />
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ១_ភាគរយនៃទ្រព្យសកម្មវិនិយោគ' : 'Q1_Percentage of Invested Asset'}
									value="valuePercent_q1"
								/>

								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ទឹកប្រាក់_ប្រាក់រៀល_(គិតជា លានរៀល)' : 'Q2_AMOUNT_KHR_In Million KHR'}
									value="valueKHR_q2"
								/>
								<ExcelColumn
									label={
										currentLang === 'kh'
											? 'ត្រីមាសទី ២_ទឹកប្រាក់_រូបិយវត្ថុអន្តរជាតិ_(គិតជា លានរៀល)'
											: 'Q2_AMOUNT_Foreign Currency_In Million KHR'
									}
									value="valueFC_q2"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ទឹកប្រាក់_សរុប_(គិតជា លានរៀល)' : 'Q2_AMOUNT_Total_In Million KHR'}
									value="valueTotal_q2"
								/>
								<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ទឹកប្រាក់_ដុល្លារ​អាមេរិក' : 'Q2_AMOUNT_USD'} value="valueUSD_q2" />
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ២_ភាគរយនៃទ្រព្យសកម្មវិនិយោគ' : 'Q2_Percentage of Invested Asset'}
									value="valuePercent_q2"
								/>

								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ទឹកប្រាក់_ប្រាក់រៀល_(គិតជា លានរៀល)' : 'Q3_AMOUNT_KHR_In Million KHR'}
									value="valueKHR_q1"
								/>
								<ExcelColumn
									label={
										currentLang === 'kh'
											? 'ត្រីមាសទី ៣_ទឹកប្រាក់_រូបិយវត្ថុអន្តរជាតិ_(គិតជា លានរៀល)'
											: 'Q3_AMOUNT_Foreign Currency_In Million KHR'
									}
									value="valueFC_q3"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ទឹកប្រាក់_សរុប_(គិតជា លានរៀល)' : 'Q3_AMOUNT_Total_In Million KHR'}
									value="valueTotal_q3"
								/>
								<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ទឹកប្រាក់_ដុល្លារ​អាមេរិក' : 'Q3_AMOUNT_USD'} value="valueUSD_q3" />
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៣_ភាគរយនៃទ្រព្យសកម្មវិនិយោគ' : 'Q3_Percentage of Invested Asset'}
									value="valuePercent_q3"
								/>

								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ទឹកប្រាក់_ប្រាក់រៀល_(គិតជា លានរៀល)' : 'Q4_AMOUNT_KHR_In Million KHR'}
									value="valueKHR_q4"
								/>
								<ExcelColumn
									label={
										currentLang === 'kh'
											? 'ត្រីមាសទី ៤_ទឹកប្រាក់_រូបិយវត្ថុអន្តរជាតិ_(គិតជា លានរៀល)'
											: 'Q4_AMOUNT_Foreign Currency_In Million KHR'
									}
									value="valueFC_q4"
								/>
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ទឹកប្រាក់_សរុប_(គិតជា លានរៀល)' : 'Q4_AMOUNT_Total_In Million KHR'}
									value="valueTotal_q4"
								/>
								<ExcelColumn label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ទឹកប្រាក់_ដុល្លារ​អាមេរិក' : 'Q4_AMOUNT_USD'} value="valueUSD_q4" />
								<ExcelColumn
									label={currentLang === 'kh' ? 'ត្រីមាសទី ៤_ភាគរយនៃទ្រព្យសកម្មវិនិយោគ' : 'Q4_Percentage of Invested Asset'}
									value="valuePercent_q4"
								/>
							</ExcelSheet>
						);
					})}
				</ExcelFile>
			</Box>
		</>
	);
}
